module.exports = __webpack_public_path__ + "static/media/calendar.173fb389.svg";